import { Api } from '../api';

export const updateUserNotificationSetting = async ({ timezone, time }: { timezone: string; time: number }) => {
  return Api.post('/notification/settings', { timezone, time });
};

export const unsubscribeUserNotification = async () => {
  return Api.delete('/notification/settings');
};

export const unsubscribeUserNotificationWithToken = async (params: { unsubToken: string; signal: AbortSignal }) => {
  const { signal, unsubToken } = params;
  return Api.post(`/notification/unsubscribe?token=${unsubToken}`, {}, { signal, withCredentials: false });
};

export const getNotificationSetting = async (signal: AbortSignal) => {
  return Api.get('/notification/settings', { signal }).then((result) => {
    return result.data;
  });
};
